'use strict';
var parent = require('../../es/set/difference');

module.exports = parent;
